export function canonicalWorkflowJSON(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(canonicalWorkflowJSON);
  if (!value || typeof value !== 'object') return value;
  return Object.fromEntries(Object.entries(value as Record<string, unknown>)
    .filter(([, nested]) => nested !== undefined)
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([key, nested]) => [key, canonicalWorkflowJSON(nested)]));
}

export function normalizeWorkflowReference(value?: string): string {
  return (value ?? '').trim().toLowerCase().replaceAll('-', '');
}
